import { render } from "./head-image.vue?vue&type=template&id=2cf5682e&scoped=true"
import script from "./head-image.vue?vue&type=script&lang=js"
export * from "./head-image.vue?vue&type=script&lang=js"

import "./head-image.vue?vue&type=style&index=0&id=2cf5682e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf5682e"]])

export default __exports__